import { Component, Input } from '@angular/core';
import { ArgyleIncomeStream } from '../models/argyle';
import * as moment from 'moment';

@Component({
  selector: 'app-income-ver-work-numba-card',
  templateUrl: './income-ver-work-numba-card.component.html',
  styleUrls: ['./income-ver-work-numba-card.component.less']
})
export class IncomeVerWorkNumbaCardComponent {
  @Input() incomeData : ArgyleIncomeStream;

  public convertDate(str : string)
  {
    const date = moment(str, "YYYYMMDDHHmmss").toDate();
    return date;
  }
}
